/**
 * In-session signal that onboarding was just completed. The OnboardingGate
 * fetches the merchant profile once (on mount) and never refetches, so without
 * this the gate would keep its stale `onboardingCompleted: false` after the
 * wizard finishes and bounce the merchant back to /welcome until a full reload.
 * The wizard flips this flag on success; the gate (which re-renders on every
 * navigation via useLocation) reads it and lets the app through. The server
 * profile reflects the real value on the next load, so this is only a
 * within-session shortcut, never the source of truth.
 */
let completedThisSession = false;

export function markOnboardingComplete(): void {
  completedThisSession = true;
}

export function onboardingWasCompleted(): boolean {
  return completedThisSession;
}

/** Test helper to reset the module-level flag between cases. */
export function resetOnboardingState(): void {
  completedThisSession = false;
}
